import DesignTokens from '@tableau/design-tokens';
import { style } from 'typestyle';

export const RelayPlanDialogStyles = {
  sectionTitle: style({
    fontWeight: 'bold',
    marginBottom: 8,
  }),

  fullWidthField: style({
    width: '100%',
    marginBottom: 8,
  }),

  planList: style({
    maxHeight: 220,
    overflowY: 'auto',
    border: `1px solid ${DesignTokens.color.elevation.border.default.subtle}`,
    borderRadius: 4,
  }),

  planOption: style({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 12px',
    border: 'none',
    background: 'transparent',
    textAlign: 'left',
    cursor: 'pointer',
    $nest: {
      '&:hover': {
        background: DesignTokens.color.elevation.surface.default.subtle,
      },
    },
  }),

  planOptionCheck: style({
    display: 'inline-flex',
    width: 16,
    marginRight: 8,
    flexShrink: 0,
  }),

  planOptionName: style({
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),

  planListEmpty: style({
    padding: '8px 12px',
    color: DesignTokens.color.font.default.secondary,
  }),

  newPlanRow: style({
    marginTop: 8,
  }),
};
